import { Movimentacoes } from './movimentacoes';
import { Tributos } from './tributos';


export class TributoItemMovimentacao {

	id: number;
	idItemMovimentacao: number;
	tributo: Tributos;
	usuarioAlteracao: number;
    
}